import { editorAnalyticsChannel } from './consts';
import { analyticsPluginKey } from './plugin-key';
function getCreateUIAnalyticsEvent(editorState) {
  var _analyticsPluginKey$g;
  return (_analyticsPluginKey$g = analyticsPluginKey.getState(editorState)) === null || _analyticsPluginKey$g === void 0 ? void 0 : _analyticsPluginKey$g.createAnalyticsEvent;
}
function getEditorAnalyticsAPI(editorState) {
  var _analyticsPluginKey$g2;
  return (_analyticsPluginKey$g2 = analyticsPluginKey.getState(editorState)) === null || _analyticsPluginKey$g2 === void 0 ? void 0 : _analyticsPluginKey$g2.editorAnalyticsApi;
}

/**
 *
 * @private
 * @deprecated
 *
 * Do not use this anymore. Please use @atlaskit/editor-plugin-analytics
 *
 */
export function addAnalytics(state, tr, payload) {
  var channel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : editorAnalyticsChannel;
  var createAnalyticsEvent = getCreateUIAnalyticsEvent(state);
  var editorAnalyticsApi = getEditorAnalyticsAPI(state);
  if (!createAnalyticsEvent || !editorAnalyticsApi) {
    return tr;
  }
  editorAnalyticsApi === null || editorAnalyticsApi === void 0 ? void 0 : editorAnalyticsApi.attachAnalyticsEvent(payload, channel)(tr);
  return tr;
}
// Below function has been copied to packages/editor/editor-plugin-ai/src/utils/analytics.ts
// If changes are made to this function, please make the same update in the linked file.
/**
 *
 * @private
 * @deprecated
 *
 * Do not use this anymore. Please use @atlaskit/editor-plugin-analytics
 *
 */
export function withAnalytics(payload, channel) {
  return function (command) {
    return function (state, dispatch, view) {
      return command(state, function (tr) {
        if (dispatch) {
          if (payload instanceof Function) {
            var dynamicPayload = payload(state);
            if (dynamicPayload) {
              dispatch(addAnalytics(state, tr, dynamicPayload, channel));
            }
          } else {
            dispatch(addAnalytics(state, tr, payload, channel));
          }
        }
      }, view);
    };
  };
}